"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var paymentClick = function (event) {
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.PaymentClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.PaymentClick,
        payment: {
            'paymentMethod': event.eventData.payment.paymentMethod || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.paymentClick = paymentClick;
